import React from 'react'
import { Tabs } from 'antd'
import { useSearchParams } from 'react-router-dom'
import { SectionTitle } from 'components/ui'
import styles from './Notifications.module.scss'
import { BroadcastForm } from './components/BroadcastForm'
import { CampaignHistory } from './components/CampaignHistory'
import { SellerPopups } from './components/SellerPopups'

const TABS = ['send', 'history', 'popups'] as const
type TTab = (typeof TABS)[number]

export const ActionsNotifications: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab') as TTab | null
  const tab: TTab = tabParam && TABS.includes(tabParam) ? tabParam : 'send'

  const changeTab = (key: string) => {
    setSearchParams(key === 'send' ? {} : { tab: key }, { replace: true })
  }

  return (
    <div className={styles.page}>
      <SectionTitle className={styles.title} level={2}>
        Глобальное уведомление
      </SectionTitle>
      <Tabs
        activeKey={tab}
        onChange={changeTab}
        items={[
          {
            key: 'send',
            label: 'Отправка',
            children: <BroadcastForm />
          },
          {
            key: 'history',
            label: 'История',
            children: <CampaignHistory active={tab === 'history'} />
          },
          {
            key: 'popups',
            label: 'Всплывающие окна',
            children: <SellerPopups active={tab === 'popups'} />
          }
        ]}
      />
    </div>
  )
}
